import { render, staticRenderFns } from "./StorageCN.vue?vue&type=template&id=1d28d2b0&scoped=true&"
import script from "./StorageCN.vue?vue&type=script&lang=js&"
export * from "./StorageCN.vue?vue&type=script&lang=js&"
import style0 from "./StorageCN.vue?vue&type=style&index=0&id=1d28d2b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28d2b0",
  null
  
)

export default component.exports